import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DelegationSliderConstants } from '../delegation-slider-constants';
import { DelegationLinkedItemsPanelListComponent } from '../delegation-linked-items-panel-list/delegation-linked-items-panel-list.component';
import { FormGroup } from '@angular/forms';
import { DocumentSearchResult } from '../../document/models/documentSearchResult';
import { DelegationInteractionService } from '../services/delegation-interaction-service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-delegation-linked-items',
  templateUrl: './delegation-linked-items.component.html',
  styleUrls: ['./delegation-linked-items.component.scss']

})
export class DelegationLinkedItemsComponent implements OnInit, AfterViewInit {
  @Output() activateTabIndex = new EventEmitter<number>();
  btnDisabled: boolean = false;
  errorMessages: string[] = [];
  delegateForm!: FormGroup;
  isDocumentSearchEnabled=true;
  isEndDateActive = false;
  isStartDateActive = false;
  isNextBtnDisplayed = false;
  isDelegateSaveInProgress = false;
  mandatoryFields: { [key: string]: boolean } =
  DelegationSliderConstants.Delegate_Default_Requiredfields;
  itemsToBeLinkedForDelegation: string[] = []
  linkedItemAlreadyExistsErrorMessage: string = DelegationSliderConstants.Linked_Item_Already_Exists_Error_Message;
  atleastOneDocumentMustBeSelectedErrorMessage: string = DelegationSliderConstants.Atleast_One_Linked_Item_Must_Be_Selected_Error_Message;
  linkedItemsConfictingErrorMessage: string = DelegationSliderConstants.linked_Item_Conflict_Error_Message;
  delegateSaveProgressMessage =  DelegationSliderConstants.Delegate_Save_InProgress;
  isDisplayAddLinkedItems: boolean = false;
  linkedItemDataToSave:any;
  delegationLinkedItems : string = DelegationSliderConstants.DelegationLinkedItems;


  @ViewChild(DelegationLinkedItemsPanelListComponent)

  private linkedItempPanelListChild!: DelegationLinkedItemsPanelListComponent;



  displayDataCollected: string[] = [];
  linkedItemDataToDisplay: any;
  @Output() sendLinkedItemsData = new EventEmitter<any>();

  constructor(private changeDetectorRef: ChangeDetectorRef,
    private delegationInteractionService: DelegationInteractionService,
    private messageService: MessageService) { }
  ngAfterViewInit(): void {
    this.linkedItemDataToDisplay = this.linkedItempPanelListChild.linkedItemDataToDisplay;
  }

  ngOnInit(): void {
    this.delegationInteractionService.closeAndResetDelegateSlider$.subscribe(
      (isClose) => {
        if (isClose) {
          this.isDocumentSearchEnabled=false;
          this.displayDataCollected = [];
          this.changeDetectorRef.detectChanges();
          this.isDocumentSearchEnabled=true;
          this.activateTabIndex.emit(0);
          this.linkedItemDataToSave = undefined;
          this.isDisplayAddLinkedItems = false;
        }
      }
    );
  }
  updateDelegate() {
    if(this.linkedItemDataToSave==undefined)
    {
      this.messageService.add({
        severity: DelegationSliderConstants.Severity_Err,
        summary: `${DelegationSliderConstants.Atleast_One_Linked_Item_Must_Be_Selected_Error_Message}`,
      });
    }
    else{
      this.sendLinkedItemsData.emit(this.linkedItemDataToSave);
    }

  }

  closeAndResetDelegateSlider() {
    this.delegateForm.reset();
    this.errorMessages = [];
    Object.keys(this.delegateForm.controls).forEach((key) => {
      this.mandatoryFields[key] = false;
    });
    this.isEndDateActive = false;
    this.isStartDateActive = false;
    // Using Angular change detection
    this.changeDetectorRef.detectChanges();
    this.isEndDateActive = true;
    this.isStartDateActive = true;
  }
  moveToPreviousTab = () => {
    this.activateTabIndex.emit(0);
    document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
  };

  addLinkedItems(docSearch: any) {
    const data = Object.assign([], this.displayDataCollected);
    this.linkedItempPanelListChild.getLinkedItems(data);
    docSearch.getLinkedItemsSelection()
  }

  linkedItemsSelectedData(event: DocumentSearchResult[]) {
    let selectedDocumentsList: string[] = [];
    event.forEach(element => {
      selectedDocumentsList.push(element.documentNumber);
    });

    this.displayDataCollected = selectedDocumentsList;
  }
  checkAndEnableAddLinkItemButton(event: boolean) {
    this.isDisplayAddLinkedItems = event;
  }
  getLinkedItemDataToSave(event:any)
  {
      this.linkedItemDataToSave=event;
  }
    
}
